<template>
    <div class="main">

        <el-button size="small" @click="venueDrawer = true" style="position: absolute;top: 50px;right: 50px;">选择项目</el-button>

        <div class="match-title" v-if="match">
            {{ match.MatchName }}
            <el-switch style="margin: 0 10px;" v-model="isAuto" active-color="#13ce66" inactive-color="#ff4949"
                :active-value="true" :inactive-value="false" :active-text="'自动刷新'">
            </el-switch>
        </div>
        <div class="detail" style="width: 100%;margin: 0 auto;display: flex;">
            <div style="width: 70%;margin:0 auto">
                <div class="project" v-if="project">
                    {{ project.GroupName + project.GenderRuleText + project.ProjectName }}({{
                        project.ContestantUser.length }} 人/队)
                </div>
                <el-table style="background-color: transparent;" :data="table.data" :highlight-current-row="false"
                    header-cell-class-name="header-name">
                    <el-table-column label="名次" align="center" prop="Ranking">
                        <template slot-scope="scope">
                            {{ scope.row.Ranking == 0 ? '' : scope.row.Ranking }}
                        </template>
                    </el-table-column>
                    <el-table-column label="区域" align="center" prop="RegionName">
                        <template v-slot="scope">
                            {{ scope.row.RegionName == 'default'?'':scope.row.RegionName }}
                        </template>
                    </el-table-column>
                    <el-table-column label="序号" align="center" prop="ComeOnGroup">
                        <template slot-scope="scope">
                            {{ scope.row.ComeOnGroup }} / {{ scope.row.ComeOnNum }}
                        </template>
                    </el-table-column>
                    <el-table-column label="运动员" align="center" prop="UserName" width="300"></el-table-column>
                    <el-table-column label="单位" align="center" prop="Unit"></el-table-column>
                    <el-table-column label="成绩" align="center" prop="Score"></el-table-column>
                    <el-table-column label="扣分次数" align="center" prop="DeductPointFrequency"></el-table-column>
                    <el-table-column label="得分" align="center" prop="TotalPoints">
                        <template slot-scope="scope">
                            {{ scope.row.TotalPoints == 0 ? '' : scope.row.TotalPoints }}
                        </template>
                    </el-table-column>
                </el-table>

                <div class="pagination-div" style="text-align: center;margin-top: 10px;">
                    <el-pagination background :current-page="table.pageIndex" :page-sizes="[10, 15, 20, 40, 60, 100]"
                        :page-size="table.pageSize" layout="total, sizes, prev, pager, next, jumper"
                        :total="table.totalRow" @size-change="pageSizeChange" @current-change="currIndexChange" />
                </div>

                <!-- <div>
                    <el-pagination background layout="prev, pager, next" :total="table.totalRow" :page-size="15">
                    </el-pagination>

                </div> -->

            </div>


        </div>

        <el-drawer :visible.sync="venueDrawer">
            <div style="padding: 30px;">
                <el-collapse v-model="activeNames">

                    <el-collapse-item v-for="(item, index) in matchWholeSchedule" :name="item.VenueId">
                        <template slot="title">
                            {{ item.VenueName }}
                        </template>
                        <div class="project-item" v-for="(pro, subIndex) in item.Projects"
                            @click="chooseProject(pro, index, subIndex)">{{ pro.GroupName + pro.GenderRuleText +
                                pro.ProjectName }}
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import MatchService from '@/request-server/request-services/match-services.js';
import SystemService from '@/request-server/request-services/system-services.js';

import Common from '@/utils/utils-common.js';
import Url from '../../../request-server/request-url';
export default {
    data() {
        return {
            routerMatchId: '',
            match: null,
            project: { ProjectName: '' },
            matchWholeSchedule: [],
            activeNames: [],
            indexMark: [],
            currIndex: -1,
            currVenueIndex: 0,
            currProIndex: 0,
            venueDrawer: false,

            table: {
                pageIndex: 1,
                pageSize: 15,
                totalPage: 0,
                totalRow: 0,
                data: []
            },
            flipInterval: null,
            pollPros: [],
            isAuto: true
        }
    },
    beforeDestroy(){
        this.matchWholeSchedule = null;
        this.project = null;
    },
    created() {
        this.initData('init');
        setInterval(() => {
            if (this.isAuto) {
                this.getNewScorePro();
            }
        }, 5000);
    },
    methods: {

        autoFlip(users) {

            if (users == null) return;

            this.table.pageIndex = 1;
            let c = 1;
            this.table.totalRow = users.length;
            let temp = users.length / this.table.pageSize;
            temp = temp.toString().indexOf('.') > -1 ? temp.toString().split('.')[0] : temp;
            this.table.totalPage = users.length % this.table.pageSize == 0 ? parseInt(temp) : parseInt(temp) + 1;
            this.table.data = this.paginate(users, this.table.pageIndex, this.table.pageSize);

            if (users == null || users.length <= this.table.pageSize) {
                clearInterval(this.interval);
                this.table.data = users;

                setTimeout(() => {
                    if (this.pollPros.length > 0) {
                        this.showPro(this.pollPros[0])
                    }
                }, 10000)

            } else {

                this.interval = setInterval(() => {
                    if (!this.isAuto) return;
                    if (this.table.pageIndex < this.table.totalPage) {
                        this.table.pageIndex++;
                        this.table.data = this.paginate(users, this.table.pageIndex, this.table.pageSize);
                    } else {
                        this.table.pageIndex = 1;
                        c++;
                        if (c >= 3 && this.pollPros.length > 0) {
                            clearInterval(this.interval);
                            this.showPro(this.pollPros[0])
                        } else {
                            this.table.data = this.paginate(users, this.table.pageIndex, this.table.pageSize);
                        }
                    }
                }, 5000);
            }
        },

        pageSizeChange(val) {
            this.table.pageSize = val;
            this.table.pageIndex = 1;
            this.autoFlip(this.project.ContestantUser)
        },

        currIndexChange(index) {
            this.table.pageIndex = index;
            this.table.data = this.paginate(this.project.ContestantUser, this.table.pageIndex, this.table.pageSize);
        },

        paginate(array, page, pageSize) {
            // 计算起始索引
            const startIndex = (page - 1) * pageSize;
            // 计算结束索引
            const endIndex = startIndex + pageSize;
            // 返回当前页的数据
            return array.slice(startIndex, endIndex);
        },

        initData(type = 'refresh', pro = '') {
            let id = this.$route.params.id;
            if (id) {
                this.routeMatchId = id;
                this.matchWholeSchedule = [];
                MatchService.getMatchWholeSchedule({ matchId: this.routeMatchId }).then(res => {
                    if (res.code == 0) {
                        this.indexMark = [];
                        let proids = [];
                        res.data.forEach((venue, index) => {
                            let v = {
                                VenueName: venue.VenueName,
                                VenueId: venue.VenueId,
                                Projects: []
                            }
                            let idx = 0;
                            venue.MatchVenueProject.forEach((pro) => {

                                let project = {
                                    GroupName: pro.Project.GroupName,
                                    GenderRuleText: pro.Project.GenderRuleText,
                                    ProjectName: pro.Project.ProjectName,
                                    ProjectId: pro.Project.ProjectId,
                                    Regions: [],
                                    ContestantUser: []
                                }

                                if (pro.Project.IsSetRanking || true) {
                                    let users = [];
                                    pro.Project.Regions.forEach(region => {
                                        region.ContestantUserGroups.forEach(group => {
                                            users = [...users, ...group.ContestantUsers]
                                        });
                                    });

                                    //有名次的
                                    if (users) {
                                        var rankUsers = users.filter(a => a.Ranking > 0);
                                        rankUsers = rankUsers.sort((a, b) => a.Ranking - b.Ranking);
                                        //没有名次的
                                        var notRankUsers = users.filter(a => a.Ranking == '' || a.Ranking == 0);
                                        notRankUsers = notRankUsers.sort((a, b) => b.Score - a.Score);
                                        users = [...rankUsers, ...notRankUsers]
                                    };
                                    console.log(users)


                                    project.ContestantUser = users;
                                }
                                if (project.ContestantUser && project.ContestantUser.length > 0) {
                                    v.Projects.push(project);
                                    this.indexMark.push(index + '-' + idx);
                                    idx++;
                                    proids.push(project.ProjectId);
                                }
                            });

                            this.matchWholeSchedule.push(v)
                            if (this.activeNames.indexOf(v.VenueId) == -1) {
                                this.activeNames.push(v.VenueId);
                            }

                            v = null;

                        })

                        res = null;
                        if (type == 'init') {
                            if (this.pollPros.length == 0 || this.pollPros.length < proids.length) {
                                this.pollPros = [...this.pollPros, ...proids];
                            }
                        }
                    };


                    if (type == 'init') {
                        if (this.table.data.length == 0) {
                            this.showPro(this.pollPros[0]);
                        }
                    } else if (type == 'refresh' && pro != '') {
                        this.showPro(pro);
                    }

                });

                if (this.match == null) {
                    MatchService.getMatchDetail({ matchId: this.routeMatchId }).then(res => {
                        if (res.code == 0) this.match = res.data;
                    })
                }
            } else {
                window.close();
            }
        },

        showPro(proId) {
            this.matchWholeSchedule.forEach(v => {
                v.Projects.forEach(pro => {
                    if (pro.ProjectId == proId) {
                        this.chooseProject(pro, '', '');
                        this.removeFirstOccurrence(pro.ProjectId);
                    }
                });
            })
        },
        removeFirstOccurrence(proId) {
            // 查找元素在数组中的第一个索引
            const index = this.pollPros.indexOf(proId);
            // 如果元素存在，则从数组中删除
            if (index > -1) {
                this.pollPros.splice(index, 1);
            }
        },

        getNewScorePro() {
            if (this.$route.params.id == '') return;
            MatchService.getLatestScorePros({ matchId: this.$route.params.id }).then(res => {
                if (res.code == 0 && res.data.length > 0) {
                    this.pollPros = [...res.data, ...this.pollPros];
                    this.initData('refresh', res.data[0]);
                }
            })
        },


        chooseProject(pro, index, subIndex) {
            clearInterval(this.interval);
            this.project = pro;
            this.autoFlip(this.project.ContestantUser)
        }
    }
}
</script>

<style lang="scss">
.main {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url('../../../assets/images/502a90c9-1a3b-4300-b3f2-56d63d69e1b8.jpg') no-repeat center center fixed;
    background-size: 100% 100%;
    overflow: hidden;
    overflow-y: auto;

    .match-title {
        font-size: 30px;
        color: #fff;
        height: 80px;
        line-height: 80px;
        padding-left: 50px;
    }

    .detail {
        .project {
            text-align: center;
            height: 50px;
            line-height: 50px;
            font-weight: 600;
            font-size: 22px;
            color: #fff;
        }
    }
}

.header-name {
    font-size: 18px !important;
    color: #000;
}

// .custom-collapse {
//     background-color: transparent !important;
// }

.el-collapse-item__header {
    color: #000;
    font-weight: 600;
    font-size: 20px;
}

.project-item {
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
    font-size: 16px;
    cursor: pointer;
}

// .el-collapse-item__content {
//     padding-bottom: 0px !important;
// }

.el-table tr {
    background-color: transparent !important;
    color: #fff;
    font-size: 24px !important;
}

.cell {
    font-size: 22px !important;
}

::v-deep .el-table .el-table__body-wrapper tbody tr:hover {
    background-color: transparent !important;
}
</style>
